import { render, staticRenderFns } from "./FileButton.vue?vue&type=template&id=7529784b&"
import script from "./FileButton.vue?vue&type=script&lang=js&"
export * from "./FileButton.vue?vue&type=script&lang=js&"
import style0 from "./FileButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports